<template lang="pug">
  #social.page
    .columns
      .column.is-2-fullhd.is-3-desktop.is-6-tablet.is-12-mobile(v-for="social of socials")
        SocialCard(v-bind="social" @update="update")
</template>

<script>
import SocialCard from "@/components/SocialCard";

export default {
  name: "social",
  components: {
    SocialCard
  },
  data() {
    return {
      cards: [
        {
          social: "telegram",
          link: "",
          status: false
        },
        {
          social: "instagram",
          link: "",
          status: false
        },
        {
          social: "x-twitter",
          link: "",
          status: false
        },
        {
          social: "facebook",
          link: "",
          status: false
        }
      ]
    };
  },
  computed: {
    socials() {
      const social = this.$store.state.social.list || [];
      return this.cards.map(c => {
        const item = social.find(s => s.social === c.social);
        return item ? item : c;
      });
    }
  },
  methods: {
    get() {
      this.$store
        .dispatch("getSocial")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Get social error",
            text
          });
        })
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "socials",
            status: false
          });
        });
    },
    update(data) {
      this.$store
        .dispatch("updateSocial", data)
        .then(res => {
          if (res) this.get();
        })
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Update social error",
            text
          });
        });
    }
  },
  mounted() {
    if (this.$store.state.social.list === null) this.get();
  }
};
</script>
